import { GaCertificateActiveButton } from "./gaia/GaCertificateActiveButton"

export const CertificateActiveButton = ({title} : {title: string}) => {

    if (window.useGaiaDesign)
        return <GaCertificateActiveButton title={title} />

    return (
        <div className="ar-certificate-active" data-testid="certificate-active-button">
            <span className="vismaicon vismaicon-filled vismaicon-success"></span>
            <button className="btn" disabled>{title}</button>
        </div>
    )
}